<template>
  <div class="basic-config">
    <!-- 预算与出价 -->
    <div class="config-section">
      <div class="section-title">预算与出价</div>
      <div class="section-body">
        <div class="form-row">
          <div class="field-label">日预算</div>
          <div class="field-control flex-center">
            <el-input v-model="config.budget" placeholder="300.00" style="width: 200px" size="small">
              <template #suffix><span class="suffix-text">元/天</span></template>
            </el-input>
            <div class="quick-budgets">
              <span class="quick-item" @click="config.budget = 300">300</span>
              <span class="sep">|</span>
              <span class="quick-item" @click="config.budget = 500">500</span>
              <span class="sep">|</span>
              <span class="quick-item" @click="config.budget = 1000">1000</span>
              <span class="sep">|</span>
              <span class="quick-item" @click="config.budget = 2000">2000</span>
            </div>
            <span class="tip-orange"><el-icon>
                <WarningFilled />
              </el-icon> 每日预算应不低于 300 元，提交后实际以配置值为准</span>
          </div>
        </div>

        <!-- <div class="form-row">
          <div class="field-label">ROI 配置模式</div>
          <div class="field-control">
            <el-radio-group v-model="roiConfigMode" size="small">
              <el-radio-button label="allSame">全部相同</el-radio-button>
              <el-radio-button label="byAccount">分账户</el-radio-button>
              <el-radio-button label="byProduct">分商品</el-radio-button>
              <el-radio-button label="byDouyin">分抖音号</el-radio-button>
            </el-radio-group>
          </div>
        </div> -->

        <!-- <div class="form-row">
          <div class="field-label">全域 ROI</div>
          <div class="field-control">
            <el-radio-group v-model="globalRoiType" size="small">
              <el-radio-button label="fixed">固定</el-radio-button>
              <el-radio-button label="ladder">阶梯</el-radio-button>
              <el-radio-button label="random">随机</el-radio-button>
            </el-radio-group>
          </div>
        </div> -->

        <div class="form-row">
          <div class="field-label">ROI</div>
          <div class="field-control flex-center">
            <el-input v-model="config.uniRoiGoal" placeholder="" style="width: 200px" size="small" />
            <span class="tip-orange"><el-icon>
                <WarningFilled />
              </el-icon> ROI 范围 0.0001 ~ 5</span>
          </div>
        </div>
      </div>
    </div>

    <!-- AIGC动态创意与标题组 -->
    <div class="config-section">
      <div class="section-title">AIGC动态创意与标题组</div>
      <div class="section-body">
        <div class="form-row">
          <div class="field-label">AIGC动态创意</div>
          <div class="field-control">
            <el-radio-group v-model="config.aigcEnabled" size="small">
              <el-radio-button :label="0">不启用</el-radio-button>
              <el-radio-button :label="1">启用</el-radio-button>
            </el-radio-group>
            <div class="tip-gray"><el-icon>
                <WarningFilled />
              </el-icon> 白名单功能，开启AIGC动态创意，请确保产品所有者在行业产品中心已申请获取原创图片的使用授权，如未完成，可能会影响素材生成效果</div>
          </div>
        </div>
        <div class="form-row">
          <div class="field-label">标题包</div>
          <div class="field-control">
            <el-select v-model="config.titlePackageId" size="small" placeholder="请选择标题包"
              @click="titlePackagegroupListFun()" @change="titlePackageChangeFun(config.titlePackageId)">
              <el-option v-for="item in config.titlePackageData" :key="item.id"
                :label="item.packageName + '（' + item.titleCount + '条）'" :value="item.id">
              </el-option>
            </el-select>
            <el-button type="text" size="small" @click="openTitlePackagePageFun()">标题包不存在？点我添加</el-button>
          </div>
        </div>
      </div>
    </div>

    <!-- 定向调控 -->
    <div class="config-section">
      <div class="section-title">定向调控</div>
      <div class="section-body">
        <div class="form-row">
          <div class="field-label">定向包</div>
          <div class="field-control">
            <el-radio-group v-model="config.directionalPackageType" size="small">
              <el-radio-button :label="0">不限</el-radio-button>
              <el-radio-button :label="1">自定义</el-radio-button>
            </el-radio-group>
          </div>
        </div>
        <div class="form-row">
          <div class="field-label"></div>
          <div class="field-control">
            <el-select v-if="config.directionalPackageType == 1" v-model="config.directionalPackageId" size="small"
              placeholder="请选择定向包" @click="packagelistFun()"
              @change="directionalPackageChangeFun(config.directionalPackageId)">
              <el-option v-for="item in config.directionalPackage" :key="item.id"
                :label="item.packageName + '（' + item.remark + '）'" :value="item.id">
              </el-option>
            </el-select>
            <el-button v-if="config.directionalPackageType == 1" type="text" size="small"
              @click="openDirectionalPackagePageFun()">定向包不存在？点我添加</el-button>
          </div>
        </div>
      </div>
    </div>

    <!-- 投放时间与时段 -->
    <div class="config-section">
      <div class="section-title">投放时间与时段</div>
      <div class="section-body">
        <div class="form-row">
          <div class="field-label">投放时间</div>
          <div class="field-control">
            <el-radio-group v-model="config.scheduleType" size="small">
              <el-radio-button :label="'SCHEDULE_FROM_NOW'">从今天长期投放</el-radio-button>
              <el-radio-button :label="'SCHEDULE_START_END'">设置开始和结束日期</el-radio-button>
            </el-radio-group>
          </div>
        </div>
        <div class="form-row" v-show="config.scheduleType === 'SCHEDULE_START_END'">
          <div class="field-label"></div>
          <div class="field-control flex-center">
            <el-date-picker v-model="config.startTime" type="date" placeholder="开始日期" size="small" style="width: 180px"
              value-format="YYYY-MM-DD" :prefix-icon="Calendar" :disabled-date="disabledBeforeToday" />
            <span class="date-sep">~</span>
            <el-date-picker v-model="config.endTime" type="date" placeholder="结束日期" size="small" style="width: 180px"
              value-format="YYYY-MM-DD" :prefix-icon="Calendar" :disabled-date="disabledBeforeToday" />
            <span v-if="isEndBeforeStart" class="tip-error">结束日期不得早于开始日期</span>
          </div>
        </div>

        <div class="form-row">
          <div class="field-label">投放时段</div>
          <div class="field-control">
            <el-radio-group v-model="config.scheduleTimeType" size="small">
              <el-radio-button :label="0">不限</el-radio-button>
              <el-radio-button :label="1">指定时间段</el-radio-button>
            </el-radio-group>
          </div>
        </div>
        <div class="form-row" v-show="config.scheduleTimeType == 1">
          <div class="field-label"></div>
          <div class="field-control">
            <weektime v-model="mult_timeRange" :data="config.weektimeData" @on-clear="clearWeektime"></weektime>
          </div>
        </div>
      </div>
    </div>

    <!-- 产品信息 -->
    <div class="config-section">
      <div class="section-title">产品信息</div>
      <div class="section-body">
        <div class="form-row">
          <div class="field-label">产品主图</div>
          <div class="field-control">
            <el-select v-model="config.productMainImageId" filterable size="small" placeholder="请选择产品主图"
              @click="productMainImagelistFun()" @change="productMainImageChangeFun(config.productMainImageId)">
              <el-option v-for="item in config.productMainImageData" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
            <el-button type="text" size="small" @click="openProductMainImagePageFun()">产品主图不存在？点我添加</el-button>
          </div>
        </div>
        <div class="form-row" v-show="config.productMainImageId != ''">
          <div class="field-label"></div>
          <div class="field-control">
            <el-image v-if="config.productMainImageUrl" :src="config.productMainImageUrl" class="product-main-image"
              fit="cover" :preview-src-list="[config.productMainImageUrl]" hide-on-click-modal />
            <div v-else class="product-main-image-placeholder">暂无图片</div>
          </div>
        </div>
        <div class="form-row">
          <div class="field-label">产品卖点</div>
          <div class="field-control flex-center">
            <el-input v-model="sellingPointInput" placeholder="空格分隔，最多10个，每个标签6-9个..." size="small" style="width: 300px"
              @keyup.enter="addSellingPointFun" />
            <el-button type="primary" size="small" @click="addSellingPointFun">添加（回车键）</el-button>
          </div>
        </div>
        <div class="form-row">
          <div class="field-label"></div>
          <div class="field-control">
            <div class="selling-point-box">
              <div class="selling-point-head">
                <span>已添加标签</span>
                <el-button type="text" size="small" @click="clearSellingPointsFun">清空 <el-icon>
                    <RefreshLeft />
                  </el-icon></el-button>
              </div>
              <div class="selling-point-tags">
                <div class="selling-point-tag" v-for="(item, index) in config.sellingPoint" :key="index">
                  <span class="tag-text">{{ item }}</span>
                  <el-icon class="tag-close" @click="removeSellingPointFun(index)">
                    <Close />
                  </el-icon>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 行动号召 -->
        <div class="form-row">
          <div class="field-label">行动号召</div>
          <div class="field-control flex-center">
            <el-input v-model="callToActionInput" placeholder="空格分隔，最多10个，每个标签2-6个..." size="small" style="width: 300px"
              @keyup.enter="addCallToActionFun" />
            <el-button type="primary" size="small" @click="addCallToActionFun">添加（回车键）</el-button>
          </div>
        </div>
        <div class="form-row">
          <div class="field-label"></div>
          <div class="field-control">
            <div class="selling-point-box">
              <div class="selling-point-head">
                <span>已添加标签</span>
                <el-button type="text" size="small" @click="clearCallToActionsFun">清空 <el-icon>
                    <RefreshLeft />
                  </el-icon></el-button>
              </div>
              <div class="selling-point-tags">
                <div class="selling-point-tag" v-for="(item, index) in config.callToAction" :key="index">
                  <span class="tag-text">{{ item }}</span>
                  <el-icon class="tag-close" @click="removeCallToActionFun(index)">
                    <Close />
                  </el-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <!-- 命名规则与状态 -->
    <div class="config-section">
      <div class="section-title">命名规则与项目状态</div>
      <div class="section-body">
        <div class="form-row">
          <div class="field-label">项目状态</div>
          <div class="field-control">
            <el-radio-group v-model="config.status" size="small">
              <el-radio-button :label="1">启用</el-radio-button>
              <el-radio-button :label="0">停用</el-radio-button>
            </el-radio-group>
          </div>
        </div>
        <div class="form-row">
          <div class="field-label">自定义抖音号名称</div>
          <div class="field-control">
            <el-input v-model="config.customDouyinName" placeholder="" clearable style="width: 200px" size="small" />
          </div>
        </div>



      </div>
    </div>
    <div class="section-body">
      <div class="form-row">
        <div class="field-label"></div>
        <div class="field-control">
          <el-button type="success" @click="returnBasicDataFun()">确定</el-button>
        </div>
      </div>
    </div>

  </div>

  <!-- 定向包 -->
  <el-dialog v-model="openPackageView" title="投放定向包管理" width="70%">
    <ylyPackage />
  </el-dialog>

  <!-- 产品主图 -->
  <el-dialog v-model="openProductMainImageView" title="产品主图管理" width="70%">
    <ylyProductImage />
  </el-dialog>

  <!-- 标题库 -->
  <el-dialog v-model="openTitlePackageView" title="标题库管理" width="70%">
    <ylyTitle />
  </el-dialog>

</template>

<script>
import { packagelist, productMainImagelist, titlePackagegroupList } from '@/request/new/ylyBatch'
import { reactive, toRefs, computed } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import { WarningFilled, Calendar, RefreshLeft, Close } from '@element-plus/icons-vue'
import ylyPackage from '@/components/ylyBatch/ylyPackage.vue'//导入定向包
import weektimeData from '@/components/weektime/weektime_data.js'//导入
import weektime from '@/components/weektime/weektime.vue'//导入时间段组件
import ylyProductImage from '@/components/ylyBatch/ylyProductImage.vue'//导入产品主图
import ylyTitle from '@/components/ylyBatch/ylyTitle.vue'//导入标题库


export default {
  name: 'ylyBasicDataConifg',
  components: { WarningFilled, ylyPackage, weektime, ylyProductImage, ylyTitle },
  emits: ['update:config'],
  props: ['data'],

  setup(props, { emit }) {
    const router = useRouter()

    const mult_timeRange = computed(() => {
      return weektimeData.map((item) => {
        return {
          id: item.row,
          week: item.value,
          value: splicing(item.child),
        }
      })
    })

    const state = reactive({
      // 获取外面的值
      config: JSON.parse(JSON.stringify(props.data)),
      // 自定义投放时间段数据
      // weektimeData: weektimeData,

      roiConfigMode: 'allSame',
      globalRoiType: 'fixed',

      aigcEnabled: true,
      openPackageView: false,
      openProductMainImageView: false,
      openTitlePackageView: false,
      targetingMode: 'unlimited',
      startDate: '',
      endDate: '',
      // 产品卖点输入
      sellingPointInput: '',
      callToActionInput: '',

      // 查询定向包
      packagelistFun: () => {
        const datas = {
          currenPage: 1,
          size: 100,
        }
        packagelist(datas).then((res) => {
          state.config.directionalPackage = res.data.data
        })
      },
      // 查询产品主图
      productMainImagelistFun: () => {
        const datas = {
          currenPage: 1,
          size: 100,
        }
        productMainImagelist(datas).then((res) => {
          state.config.productMainImageData = res.data.data
        })
      },
      // 查询标题库
      titlePackagegroupListFun: () => {

        titlePackagegroupList().then((res) => {
          state.config.titlePackageData = res.data
        })
      },

      // 标题包改变：同步标题包名称快照
      titlePackageChangeFun: (data) => {
        if (data === '' || data === null || data === undefined) {
          state.config.titlePackageName = ''
          return
        }
        const item = (state.config.titlePackageData || []).find(item => item.id == data)
        state.config.titlePackageName = item ? item.packageName : ''
      },
      // 定向包改变：同步定向包名称快照
      directionalPackageChangeFun: (data) => {
        if (data === '' || data === null || data === undefined) {
          state.config.directionalPackageName = ''
          return
        }
        const item = (state.config.directionalPackage || []).find(item => item.id == data)
        state.config.directionalPackageName = item ? item.packageName : ''
      },
      // 赋值图片显示
      productMainImageChangeFun: (data) => {
        // 因为传入的是imgId
        console.log('赋值图片显示', data)
        if (data !== '' && data !== null && data !== undefined) {
          const item = (state.config.productMainImageData || []).find(item => item.id == data)
          console.log('赋值图片显示item', item)
          state.config.productMainImageUrl = item ? item.url : ''
          state.config.productMainImageName = item ? item.name : ''
        } else {
          state.config.productMainImageUrl = ''
          state.config.productMainImageName = ''
        }

      },
      // 跳转定向包页面
      openDirectionalPackagePageFun: () => {
        // const routeData = router.resolve({
        //   path: '/ylyPackage',
        // })
        // window.open(routeData.href, '_blank')
        state.openPackageView = true
      },
      // 跳转产品主图页面
      openProductMainImagePageFun: () => {
        state.openProductMainImageView = true
      },
      // 跳转标题库页面
      openTitlePackagePageFun: () => {
        state.openTitlePackageView = true
      },


      // 清除投放时段的值
      clearWeektime: () => {
        state.config.weektimeData.forEach((item) => {
          item.child.forEach((t) => {
            t.check = false
          })
        })
      },
      // 确定抛出数据
      returnBasicDataFun: () => {
        const c = state.config

        // ==========预算与出价==========
        if (c.budget === null || c.budget === undefined || c.budget === '') {
          ElMessage.error('请填写日预算')
          return
        }
        if (Number(c.budget) < 300) {
          ElMessage.error('每日预算应不低于 300 元')
          return
        }
        if (c.uniRoiGoal === null || c.uniRoiGoal === undefined || c.uniRoiGoal === '') {
          ElMessage.error('请填写 ROI')
          return
        }
        const roi = Number(c.uniRoiGoal)
        if (Number.isNaN(roi) || roi < 0.0001 || roi > 5) {
          ElMessage.error('ROI 范围 0.0001 ~ 5')
          return
        }

        // ==========定向调控（自定义时必选定向包）==========
        if (Number(c.directionalPackageType) === 1 && !c.directionalPackageId) {
          ElMessage.error('请选择定向包')
          return
        }
        // ==========标题调控（自定义时必选标题包）==========
        if (c.titlePackageId == '') {
          ElMessage.error('请选择标题包')
          return
        }

        // ==========投放时间与时段==========
        if (c.scheduleType === 'SCHEDULE_START_END') {
          if (!c.startTime || !c.endTime) {
            ElMessage.error('请选择投放开始和结束日期')
            return
          }
          if (new Date(c.endTime).getTime() < new Date(c.startTime).getTime()) {
            ElMessage.error('结束日期不得早于开始日期')
            return
          }
        }
        // 指定时间段时，至少要勾选一个时段
        if (Number(c.scheduleTimeType) === 1) {
          const hasChecked = (c.weektimeData || []).some((day) =>
            (day.child || []).some((t) => t.check)
          )
          if (!hasChecked) {
            ElMessage.error('请选择投放时间段')
            return
          }
        }

        // ==========产品信息==========
        if (!c.productMainImageId) {
          ElMessage.error('请选择产品主图')
          return
        }
        if (!c.productMainImageUrl) {
          ElMessage.error('产品主图地址为空，请重新选择')
          return
        }
        if (!c.sellingPoint || c.sellingPoint.length === 0) {
          ElMessage.error('请至少添加一个产品卖点')
          return
        }
        if (!c.callToAction || c.callToAction.length === 0) {
          ElMessage.error('请至少添加一个行动号召')
          return
        }

        // ==========命名规则与项目状态==========
        if (c.status === null || c.status === undefined || c.status === '') {
          ElMessage.error('请选择项目状态')
          return
        }
        if (!c.customDouyinName || !String(c.customDouyinName).trim()) {
          ElMessage.error('请填写自定义抖音号名称')
          return
        }


        // 全部通过，抛出配置并关闭由父组件控制
        emit('update:config', JSON.parse(JSON.stringify(state.config)))
      }


    })

    // 今天之前不可选（含今天可选）
    const disabledBeforeToday = (time) => {
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      return time.getTime() < today.getTime()
    }

    // ==========产品卖点==========
    // 添加卖点（回车或点击添加，空格分隔批量添加）
    const addSellingPointFun = () => {
      const value = (state.sellingPointInput || '').trim()
      if (!value) {
        ElMessage.warning('请输入产品卖点')
        return
      }
      if (!state.config.sellingPoint) {
        state.config.sellingPoint = []
      }
      // 以空格分割成多个标签
      const tags = value.split(/\s+/).filter((t) => t !== '')
      for (const tag of tags) {
        if (state.config.sellingPoint.length >= 10) {
          ElMessage.warning('最多添加10个标签')
          break
        }
        if (tag.length < 6 || tag.length > 9) {
          ElMessage.warning(`标签「${tag}」需要6-9个字`)
          continue
        }
        if (state.config.sellingPoint.includes(tag)) {
          ElMessage.warning(`标签「${tag}」已存在`)
          continue
        }
        state.config.sellingPoint.push(tag)
      }
      state.sellingPointInput = ''
    }
    // 删除单个卖点
    const removeSellingPointFun = (index) => {
      state.config.sellingPoint.splice(index, 1)
    }
    // 清空卖点
    const clearSellingPointsFun = () => {
      state.config.sellingPoint = []
    }


    // ==========行动号召（和产品卖点逻辑一致，绑定 config.callToAction）==========
    const addCallToActionFun = () => {
      const value = (state.callToActionInput || '').trim()
      if (!value) {
        ElMessage.warning('请输入行动号召')
        return
      }
      if (!state.config.callToAction) {
        state.config.callToAction = []
      }
      // 以空格分割成多个标签
      const tags = value.split(/\s+/).filter((t) => t !== '')
      for (const tag of tags) {
        if (state.config.callToAction.length >= 10) {
          ElMessage.warning('最多添加10个标签')
          break
        }
        if (tag.length < 2 || tag.length > 6) {
          ElMessage.warning(`标签「${tag}」需要2-6个字`)
          continue
        }
        if (state.config.callToAction.includes(tag)) {
          ElMessage.warning(`标签「${tag}」已存在`)
          continue
        }
        state.config.callToAction.push(tag)
      }
      state.callToActionInput = ''
    }
    // 删除单个行动号召
    const removeCallToActionFun = (index) => {
      state.config.callToAction.splice(index, 1)
    }
    // 清空行动号召
    const clearCallToActionsFun = () => {
      state.config.callToAction = []
    }

    const isEndBeforeStart = computed(() => {
      if (!state.config.startTime || !state.config.endTime) return false
      return new Date(state.config.endTime).getTime() < new Date(state.config.startTime).getTime()
    })

    const splicing = (list) => {
      let same
      let i = -1
      const len = list.length
      const arr = []

      if (!len) {
        return
      }
      while (++i < len) {
        const item = list[i]

        if (item.check) {
          if (item.check !== Boolean(same)) {
            arr.push(...['、', item.begin, '~', item.end])
          } else if (arr.length) {
            arr.pop()
            arr.push(item.end)
          }
        }
        same = Boolean(item.check)
      }
      arr.shift()
      console.log(arr.shift())

      return arr.join('')
    }

    return {
      ...toRefs(state),
      Calendar,
      WarningFilled,
      disabledBeforeToday,
      isEndBeforeStart,
      mult_timeRange,
      addSellingPointFun,
      removeSellingPointFun,
      clearSellingPointsFun,

      addCallToActionFun,
      removeCallToActionFun,
      clearCallToActionsFun,
    }
  },
}
</script>

<style lang="scss" scoped>
.basic-config {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.config-section {
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  overflow: hidden;
}

.section-title {
  padding: 12px 16px;
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  border-bottom: 1px solid #ebeef5;
  background: #fff;
}

.section-body {
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.form-row {
  display: flex;
  align-items: flex-start;
  gap: 16px;
}

.field-label {
  width: 110px;
  flex-shrink: 0;
  font-size: 13px;
  color: #606266;
  line-height: 32px;
}

.field-control {
  flex: 1;
  min-width: 0;
}

.flex-center {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.suffix-text {
  color: #909399;
  font-size: 12px;
}

.quick-budgets {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
}

.quick-item {
  color: #409eff;
  cursor: pointer;

  &:hover {
    color: #66b1ff;
  }
}

.sep {
  color: #c0c4cc;
}

.tip-orange {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #e6a23c;

  :deep(.el-icon) {
    font-size: 12px;
  }
}

.tip-gray {
  margin-top: 8px;
  display: flex;
  align-items: flex-start;
  gap: 4px;
  font-size: 12px;
  color: #909399;
  line-height: 1.6;

  :deep(.el-icon) {
    margin-top: 2px;
    color: #e6a23c;
    flex-shrink: 0;
  }
}

.date-sep {
  color: #909399;
  padding: 0 4px;
}

.tip-error {
  color: #f56c6c;
  font-size: 12px;
  margin-left: 4px;
}

/* 产品主图预览 */
.product-main-image {
  width: 108px;
  height: 108px;
  border-radius: 6px;
  border: 1px solid #ebeef5;
  cursor: pointer;
}

.product-main-image-placeholder {
  width: 108px;
  height: 108px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #909399;
  background: #f5f7fa;
  border: 1px dashed #dcdfe6;
  border-radius: 6px;
}

:deep(.el-radio-button__inner) {
  min-width: 80px;
}

/* 产品卖点标签区 */
.selling-point-box {
  width: 460px;
  min-height: 180px;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  overflow: hidden;
}

.selling-point-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 12px;
  font-size: 13px;
  color: #606266;
  background: #f5f7fa;
  border-bottom: 1px solid #ebeef5;
}

.selling-point-tags {
  padding: 12px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.selling-point-tag {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  font-size: 13px;
  color: #303133;
  background: #f0f2f5;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background: #e8eaf0;
  }
}

.tag-text {
  max-width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tag-close {
  font-size: 12px;
  color: #909399;
  cursor: pointer;

  &:hover {
    color: #f56c6c;
  }
}
</style>
